import { animate, state, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GiftcardService } from '@src/app/ecom-gift-card/ecom-giftcard.service';
import { Discount } from '@src/app/ecom-models/discount';
import { User } from '@src/app/ecom-models/user';
import { EcomCartService } from '@src/app/ecom-services/ecom-cart.service';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';
import { QRType } from '@src/app/enums/qr-types.enum';
import { ToastService } from '@src/app/toast/toast.service';
import moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { generateGuid } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { EcomOlarDataService } from 'src/app/ecom-data-services/ecom-olar-data-service';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { default as olarconfig } from '../../../assets/olarconfig.json';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
import { CategoryClass } from '../ecom-item-category/ecom-item-category.model';


@Component({
  selector: 'new-app-ecom-item-category',
  templateUrl: './new-ecom-item-category.component.html',
  styleUrls: ['./new-ecom-item-category.component.scss'],
  animations: [
    trigger('myInsertRemoveTrigger', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('100ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('100ms', style({ opacity: 0 }))
      ])
    ]),
    trigger('inOutAnimation', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [style({ opacity: '0' }), animate('.5s ease-out', style({ opacity: '1' }))]),
      transition(':leave', [style({ opacity: '1' }), animate('.5s ease-out', style({ opacity: '0' }))]),
    ]),
  ],
})
export class NewEcomItemCategoryComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('sentinel') sentinels!: QueryList<ElementRef>;
  @ViewChildren('sectionEl') sectionEls!: QueryList<ElementRef>;
  @ViewChildren('catItem') catItems!: QueryList<ElementRef>;
  @ViewChild('scrollRoot', { static: true }) scrollRoot!: ElementRef;
  @ViewChild('categoryScroll', { static: false }) categoryScroll!: ElementRef;
  private observers: IntersectionObserver[] = [];
  isToday = true;
  categoryList: CategoryClass[] = [];
  //itemList = [];

  itemTotalAmount = 100;
  locationSelected: any;
  locationName = '';
  serviceType = '';
  userServiceBase: UserServiceBase;
  userSelectedStore: StoreServiceBase;
  storeServiceBase: StoreServiceBase;

  settings: any;

  modalRef: BsModalRef;

  qrCodeScanned = false;
  displaymenutop = true;

  defaultItemImage = './assets/images/Itemdefault.jpeg';
  defaultImage = './assets/images/Itemdefault.jpeg';
  companyName = '';
  locationAddress = '';

  locationDetails: any = '';
  serviceErrorMessage: any;

  username = '';
  today: string;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  selectedCountryISO: any = CountryISO.Malaysia;
  preferredCountries: CountryISO[] = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];

  timeList = [];
  IsTableQRCode = false;
  IsLocationQRCode = false;
  IsWebUrl = false;

  webCompanyId: any;
  closedTodayMessage = '';
  pagereload = false;
  categoryListResponse = [];
  recommendedItems = [];
  environment: any;
  // order status popup

  configorderstatus = {
    ignoreBackdropClick: true,
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered modal-sm'
  };

  showALTLanguage: boolean = false;

  isHorizontalMenu = false;
  selectedMenuId: number = 0;
  itemList: any;
  subMenus: any[] = [];
  newCategoryList: CategoryClass[] = [];
  showSubmenu: boolean;
  showSideBar: boolean;
  selectedSubMenuId: number = 0;
  showMenuId: number = 0;
  searchForm: FormGroup;
  showRecommended: boolean = false;
  tableName: string = "";
  discounts: Discount[] = [];
  queryCategoryId: number;

  bsModalRef: BsModalRef;
  showDetails: boolean = false;
  shoppingCart: any;
  toastMessage: string = '';
  showToast: boolean = false;
  drawerVisible = false;
  onClose: any;
  item_pkid: number;
  iscvsd_pkid: number;
  category_pkid: number;
  showOurMenu = true;

  banners: string[] = [];
  showBanner: boolean = false;
  selectedTime = '';
  selectedDate = '';
  backdrop: boolean = false;
  qrCodeType: number = 1;
  userInfo: User;
  // constructor to inject the class objects
  newCategoryItems: any[] = [];

  addonSelectedSubMenuId: any;

  allCategoryList: any[] = [];
  showGiftCard: boolean;

  showOrderTypePopup: boolean = false;
  companyLogo = "";

  constructor(private zone: NgZone, public ecomOlarDataService: EcomOlarDataService, public router: Router, public ecomservice: EComService, private webstorage: EComWebStorage, private cookie: EcomCookies, public formBuilder: FormBuilder,
    private modalService: BsModalService, public location: Location,
    public activatedRoute: ActivatedRoute, { nativeElement }: ElementRef<HTMLImageElement>,
    private cartService: EcomCartService,
    private toastService: ToastService,
    private settingService: EcomSettingService,
    public giftcardService: GiftcardService,
    private cdr: ChangeDetectorRef) {
    this.userServiceBase = new UserServiceBase();
    this.userSelectedStore = new StoreServiceBase({});
    this.shoppingCart = this.webstorage.localSt_shopping_cart;
    const supports = 'loading' in HTMLImageElement.prototype;
    if (supports) {
      nativeElement.setAttribute('loading', 'lazy');
    }
    this.environment = olarconfig.Environment;
    this.toastService.message$.subscribe(message => {
      this.toastMessage = message;
    });

    this.toastService.visibility$.subscribe(visible => {
      this.showToast = visible;
    });

    this.ecomOlarDataService.currentMenu.subscribe(menulist => {
      this.categoryListResponse = menulist;
    });
    this.ecomOlarDataService.currentMenunew.subscribe(menulist => {
      this.categoriesResponse = menulist;
    });

    this.settingService.currentCompanySetting.subscribe(setting => {
      if (!setting) return;

      this.serviceType = setting.serviceType;
      this.tableName = setting.tableName;
    });

    this.settingService.currentLocationSetting.subscribe(location => {
      if (!location) return;

      this.userSelectedStore = this.settingService.getSelectedStore(this.serviceType);
    });

    this.settingService.currentUserServiceBase.subscribe(userBase => {
      if (!userBase) return;

      this.selectedDate = userBase.selectedDate;
      this.selectedTime = userBase.selectedTime;
    });

    this.settingService.currentQRCodeType.subscribe(value => {
      this.IsTableQRCode = value === QRType.Table;
      this.showBanner = !this.IsTableQRCode;
      const self = this;
      this.qrCodeType = value;


    });

    this.settingService.currentUserInfo.subscribe(user => {
      this.userInfo = user;
    });


  }



  selectedLanguage: string;
  onLanguageSelected(language: string) {
    this.selectedLanguage = language;
    this.showALTLanguage = language === "zh";

  }

  openDetailDrawer(item) {
    this.drawerVisible = true;
    this.onClose = this.onDrawerVisibleChange.bind(this);
    this.item_pkid = item.item_pkid;
    this.iscvsd_pkid = item.ooip_iscvsd_pkid;
    this.category_pkid = !item.ooic_pkid ? null : item.ooic_pkid;
  }

  onDrawerVisibleChange($event) {
    this.drawerVisible = false;
    this.cartService.updateCart(this.webstorage.sessionSt_cart_item, this.locationSelected.mm_online_order_location_settings.ools_location_pkid, this.categoryList);

    this.userServiceBase = this.settingService.getUserSerivce();
    const selectedStore = this.settingService.getSelectedStore(this.serviceType);

    if (selectedStore) {
      this.userSelectedStore = selectedStore;
    }
  }



  hideModal() {
    this.cartService.updateCart(this.webstorage.sessionSt_cart_item, this.locationSelected.mm_online_order_location_settings.ools_location_pkid, this.categoryList);

    this.userServiceBase = this.settingService.getUserSerivce();
    const selectedStore = this.userServiceBase.selectedStoreServiceList.find(obj =>
      obj.locationPkid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid
      && !obj.serviceCompleted
      && obj.serviceType === this.serviceType);

    if (selectedStore) {
      this.userSelectedStore = selectedStore;
    }
    this.bsModalRef.hide();
  }

  toggleSubMenu(event: MouseEvent, item, i) {
    //console.log("debbug");
    this.showMenuId = item.ooic_pkid;
    this.showSubmenu = !this.showSubmenu;
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if (!this.item_searched) {
      if (window.pageYOffset > 500) {
        let element = document.getElementById('navbar-item');
        if (element) {
          element.classList.add('location-sticky');
          element.classList.add('margin-top-0');
          element.classList.add('search-display-block');
          element.classList.remove('search-display-none');
        }
      } else {
        let element = document.getElementById('navbar-item');
        if (element) {
          element.classList.remove('location-sticky');
          element.classList.remove('margin-top-0');
          element.classList.remove('search-display-block');
          element.classList.add('search-display-none');
        }
      }
    }
  }



  @ViewChild('paxModal', { static: true }) paxModal: ElementRef;

  modalRefPaxModal: BsModalRef;


  showBuyGiftCard = false;

  onAndroidClick() {
    window.open('https://play.google.com/store/apps/details?id=com.merchantmate.mmolarme', "_blank");
  }

  onIOSClick() {
    window.open('https://apps.apple.com/app/olarme/id1606881014', "_blank");
  }



  addPax(pax: number) {
    const userInfo = this.settingService.getUserInfo();
    userInfo.pax = pax;
    this.settingService.setUserInfo(userInfo);

    this.modalRefPaxModal.hide();
  }

  // component initialize and load the required data
  async ngOnInit() {
    const userInfo = this.settingService.getUserInfo();
    if (this.serviceType === "DINE_IN" && userInfo.pax === 0) {
      this.modalRefPaxModal = this.modalService.show(this.paxModal, { ...this.configorderstatus, class: 'modal-dialog-centered modal-pax' });
    }

    if (!this.settingService.getCompanySetting()) {
      this.router.navigate(['home']);
      return;
    }

    this.pagereload = true;
    this.username = this.webstorage.localSt_name ? this.webstorage.localSt_name : (this.userServiceBase ? this.userServiceBase.userName : '');
    this.loadStoreFormControls()
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.categoryList = [];


    if (this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) {
      //this.callGetCategoryItems = true;
      this.qrCodeScanned = this.webstorage.sessionSt_qr_code_scanned;
      this.displaymenutop = false;
    }

    // if (!this.cookie.cookie_user_location && (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
    //   this.modalRef = this.modalService.show(this.userlocationpopup, this.configlocationpopup);
    // }

    this.activatedRoute.paramMap.subscribe(params => {
      let merchatname: any = params.get('companyname');
      this.webstorage.sessionSt_company_clicked = merchatname.trim().replace(/\s+/g, '-').toLowerCase();
    });

    this.activatedRoute.queryParams.subscribe(async params => {
      //console.log("debbug");
      // if (!params['ok']) {
      //   const queryParams = params['T'] ? { T: params['T'] } : (params['L'] ? { L: params['L'] } : {});
      //   this.router.navigate(['loginnew'], { queryParams });
      //   return;
      // }
      if (params['T'] || params['L']) {

        this.webstorage.sessionSt_is_session_valid = 'YES';
        // if it is qr code scan then initialize the new userbase and it'll clears all the previous data
        // to avoid the cart mismatch
        //this.webstorage.localSt_user_service_request = undefined;
        this.settingService.setUserSerivce(undefined);
        this.userServiceBase = new UserServiceBase();
        //this.callGetCategoryItems = true;
        this.displaymenutop = false;
        //this.QRCodeUrlRequest(params['data']);
        this.webstorage.localSt_YourVersion = olarconfig.ReleaseVersion;
        const model = params['T'] ? { tableCode: +params['T'] } : (params['L'] ? { locationCode: +params['L'] } : {});
        await this.QRCodeUrlRequest(model);
      } else {
        // if (!this.webstorage.sessionSt_is_session_valid) {
        //   this.router.navigate(['home']);
        // }
        const locationSetting = this.settingService.getLocationSetting();
        // let locationPkid = this.settingService.getLocationSetting().mm_online_order_location_settings.ools_location_pkid;
        if (!locationSetting) return;
        const setting = this.settingService.getCompanySetting();
        let QRData = {
          storeSettingId: setting['oocls_pkid'],
          locationId: setting['oocls_location_pkid'],
          tableId: setting.tablePkid,
          tableName: setting.tableName,
        };

        await this.QRCodeGetCompanySettings(QRData);

        if (params['category']) {
          this.queryCategoryId = +params['category'];

        }
      }
    });

    if (this.webstorage.sessionSt_weburl_order) {
      this.IsTableQRCode = false;
      this.IsLocationQRCode = false;
      this.IsWebUrl = true;
    }
    if (this.webstorage.sessionSt_qrcode_type) {
      if (this.webstorage.sessionSt_qrcode_type === 'QRSTORE') {
        this.IsTableQRCode = false;
        this.IsLocationQRCode = true;
      } else {
        this.IsTableQRCode = true;
        this.IsLocationQRCode = false;
      }
      this.IsWebUrl = false;
    }


    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchTextValue => {
      this.searchItem(searchTextValue);
    });
  }

  async fetchGiftcard() {
    const setting = this.settingService.getCompanySetting();

    if (setting && setting.oocls_company_id) {
      // Cached in GiftcardService: only hits the API once per app session,
      // reused on navigation, refetched on full page refresh.
      this.showBuyGiftCard = await this.giftcardService.hasGiftcards(setting.oocls_company_id);
    }
  }

  ngAfterViewInit() {
    this.sentinels.changes.subscribe(() => {
      //console.log('[VIEW] sentinels changed');
      this.setupObservers();
    });

    setTimeout(() => this.setupObservers(), 0);
  }


  ngOnDestroy() {
    this.disconnectObservers();
  }

  // ---- Scrollspy: highlight the category whose section is at the top ----
  // Computed straight from scroll position (deterministic) instead of an
  // IntersectionObserver band, which highlighted the previous section.
  private updateActiveOnScroll(container: HTMLElement) {
    const arr = this.sectionEls ? this.sectionEls.toArray() : [];
    if (!arr.length) return;

    // A reference line just below the top of the scroll viewport.
    const line = container.getBoundingClientRect().top + 60;

    // Active = the LAST section whose top has scrolled above the line, i.e.
    // the section currently occupying the top of the viewport.
    let activeIdx = 0;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].nativeElement.getBoundingClientRect().top <= line) {
        activeIdx = i;
      } else {
        break;
      }
    }

    const category = this.newCategoryList[activeIdx];
    if (!category || this.selectedMenuId === category.ooic_pkid) return;

    // Runs inside Angular's zone (template (scroll) handler), so CD is automatic.
    this.selectedMenuId = category.ooic_pkid;
    this.centerCategoryInStrip(activeIdx);
  }

  // Scroll the horizontal strip so the active circle is centered.
  // Uses getBoundingClientRect so it works regardless of offsetParent
  // (.category-scroll is position:static, so offsetLeft can't be trusted).
  private centerCategoryInStrip(index: number) {
    if (!this.catItems) return;
    const items = this.catItems.toArray();
    const item = items[index] ? (items[index].nativeElement as HTMLElement) : null;
    if (!item) return;

    // Prefer the ViewChild; fall back to walking up from the item so this
    // never silently no-ops if the ViewChild hasn't resolved yet.
    const container = (this.categoryScroll && this.categoryScroll.nativeElement)
      ? this.categoryScroll.nativeElement as HTMLElement
      : item.closest('.category-scroll') as HTMLElement;
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const target = container.scrollLeft
      + (itemRect.left - containerRect.left)
      - (container.clientWidth / 2)
      + (itemRect.width / 2);

    // Assign scrollLeft directly (works on every browser/webview); the
    // smooth animation comes from CSS `scroll-behavior: smooth` on the strip.
    container.scrollLeft = target;
  }

  private disconnectObservers() {
    for (let i = 0; i < this.observers.length; i++) {
      this.observers[i].disconnect();
    }
    this.observers = [];
  }


  private setupObservers() {
    this.disconnectObservers();

    let sentinelArr = [];
    if (this.sentinels && this.sentinels.toArray) {
      sentinelArr = this.sentinels.toArray();
    }

    if (!sentinelArr.length) {
      //console.log('[VIEW] no sentinel -> skip');
      return;
    }

    sentinelArr.forEach((elRef, idx) => {
      const menu = this.newCategoryList[idx];
      if (!menu) {
        return;
      }

      const io = new IntersectionObserver((entries) => {
        for (let i = 0; i < entries.length; i++) {
          const e = entries[i];
          if (!e.isIntersecting) continue;

          // console.log(
          //   '[IO] in viewport -> menuId=' + menu.ooic_pkid +
          //   ' name=' + menu.ooic_name +
          //   ' loaded=' + menu.loaded +
          //   ' loading=' + menu.loading
          // );

          this.loadMenuFirstTime(menu);
        }
      }, {
        root: this.scrollRoot.nativeElement,
        threshold: 0,
        rootMargin: '0px'
      });

      io.observe(elRef.nativeElement);
      this.observers.push(io);
    });

    //console.log('[VIEW] observers bound = ' + this.observers.length);
  }

  scrollToNew(index: number) {
    const arr = this.sectionEls.toArray();
    if (!arr[index]) return;

    const container = this.scrollRoot.nativeElement as HTMLElement;
    const section = arr[index].nativeElement as HTMLElement;

    // Strip now lives in the navbar (above this container), so the section
    // only needs a small gap from the top.
    const offset = 8;

    const cRect = container.getBoundingClientRect();
    const sRect = section.getBoundingClientRect();
    const top = container.scrollTop + (sRect.top - cRect.top) - offset;

    // Scroll ONLY this container. scrollIntoView() would also scroll the
    // window on mobile (app-shell taller than the viewport), dragging the
    // navbar + category strip out of view.
    container.scrollTop = top;
  }

  getActiveSubItems(category: any) {
    if (!category || !category.subMenus || !category.subMenus.length) return [];

    var activeId = category.activeSubMenuId;
    for (var i = 0; i < category.subMenus.length; i++) {
      var sm = category.subMenus[i];
      if (sm.id === activeId) {
        return sm.items || [];
      }
    }
    return [];
  }
  onSubMenuClickNew(cat, sub: CategoryClass, index) {
    cat.activeSubMenuId = sub.ooic_pkid;
    cat.activeSubMenu = sub;
  }

  onAddonSubMenuClickNew(cat, sub: CategoryClass, index) {
    cat.activeAddonSubMenuId = sub.ooic_pkid;
    cat.activeAddonSubMenu = sub;
  }

  private async loadMenuFirstTime(menu) {
    const companyId = this.locationSelected.company_id;
    const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;

    if (menu.loaded || menu.loading) return;

    // Recommended items already loaded => skip
    if (menu.ooic_pkid === 0) {
      menu.loaded = true;
      return;
    }



    let isCatagoryAvailable = menu.active;

    // isCatagoryAvailable = this.isNowInTimeRange(slot.StartTime, slot.EndTime);


    const byName = (a: any, b: any) =>
      a.item_name.localeCompare(b.item_name, undefined, { numeric: true });

    menu.loading = true;
    console.log(`[API] CALL items for menuId=${menu.ooic_name}`);

    const res = await this.getItemsByCategory(companyId, locationPkid, menu.ooic_pkid);
    // check res null/undefined
    const list = (res && res.length) ? res : [];
    let items = [];

    if (list.length) {

      list.forEach(element => {

        let categoryActive = true;

        if (menu.ooic_pkid === element.ooic_pkid) {
          categoryActive = isCatagoryAvailable;
        } else {
          const findMenu = this.newCategoryList.find(x => x.ooic_pkid === element.ooic_pkid);
          if (findMenu) {
            //const slot = findMenu.timeList[0];
            categoryActive = findMenu.active;
          }
        }

        if (!element.ItemPricingDineIn) return;

        element.ItemPricingDineIn.forEach(elementitem => {


          let itemprice = elementitem.ooip_price_value;
          let discountedPrice = 0;

          const categoryItemAvailable = categoryActive && elementitem.ooip_is_active;
          //console.log("debbug");
          const item = this.mapItemData(elementitem, elementitem.item_description, categoryItemAvailable, itemprice, discountedPrice, element.ooic_parent_pkid, element.ooic_pkid)
          items.push(item);
        });

      });

      //console.log("new", items);
    }

    //
    if (!menu.subMenus.length) {
      menu.items = items.filter(x => x.ooic_pkid === menu.ooic_pkid).sort(byName);
    }
    else {
      menu.subMenus.forEach(sub => {
        const subItems = items.filter(x => x.ooic_pkid === sub.ooic_pkid);
        sub.items = subItems.sort(byName);
      });

      menu.activeSubMenu = menu.subMenus[0];
    }

    // 3) Addon
    if (menu.addon_pkid) {

      const addonMenu = this.allCategoryList.find((x: any) => x.ooic_pkid === menu.addon_pkid);

      if (addonMenu) {
        menu.addon_items = items.filter(x => x.ooic_pkid === addonMenu.ooic_pkid);

        // If has subMenus, first sub menu is priority
        const addOnSubMenus = this.allCategoryList.filter((x: any) => x.ooic_parent_pkid === addonMenu.ooic_pkid);

        if (addOnSubMenus.length) {
          menu.addonSubMenus = addOnSubMenus;
          menu.addon_items = [];

          addOnSubMenus.forEach(sub => {
            const subItems = items.filter(x => x.ooic_pkid === sub.ooic_pkid);
            sub.items = subItems.sort(byName);
          });

          menu.activeAddonSubMenuId = addOnSubMenus[0].ooic_pkid;
          menu.activeAddonSubMenu = addOnSubMenus[0];
        }
      }
    }


    //console.log(111, items)

    menu.loaded = true;
    menu.loading = false;

    //console.log('[API] DONE menuId=' + menu.ooic_name + ' items=' + menu.items.length);


  }
  async fetchCustomerLoyalty() {
    const user = this.settingService.getUserInfo();
    if (!user.userPkid) return;

    const setting = this.settingService.getCompanySetting();

    const model = {
      type: this.serviceType,
      companyId: setting.oocls_company_id,
      locationPkid: setting.oocls_location_pkid,
      customer_pkid: user.userPkid
    }

    const response = await this.ecomservice.httpPost(`${EcomNetworkUtils.GET_OLAR_CUSTOMER_LOYALTY}`, model, '', true)
      .toPromise();
    //console.log(response);
    if (response.isSuccess && response.listValue) {
      //this.customerLoyalty = response.listValue;
      const data = response.listValue;
      this.settingService.setUserInfo(new User({
        ...user,
        originPoints: data.points,
        points: data.points,
        loyalty_tier: data.loyalty_tier,
        amount: data.points && data.ratio ? Number(data.points / data.ratio) : 0,
        maximum_redemtion: data.maximum_redemtion,
        amountUnit: data.amountUnit,
        pointsPerUnit: data.pointsPerUnit,
        earnPointTaxMode: data.earnPointTaxMode,
        minOrderAmountForPoints: data.minOrderAmountForPoints,
        maxUses: data.maxUses,
        ratio: data.ratio,
        programCurrency: data.programCurrency,
        month: data.month,
        next_tier: data.next_tier,
        spend_more: data.spend_more
      }));
    }

  }

  async getDiscounts(locationPkid: number) {
    if (this.settingService.getDiscounts().length) return;

    const companyId = this.locationSelected.company_id;
    const response = await this.ecomservice.httpGet(`${EcomNetworkUtils.GET_DISCOUNTS_BY_LOCATION_ID}?companyId=${companyId}&locationId=${locationPkid}`, '', false)
      .toPromise();
    if (response.status === 200) {
      const discounts = response.listValues.map(x => new Discount(x));
      this.settingService.setDiscounts(discounts);
    }

  }

  loadStoreFormControls() {
    this.searchForm = this.formBuilder.group({
      searchValue: []
    });


  }

  //request from qrcodes  - methods
  async QRCodeUrlRequest(QRData) {
    this.webstorage.sessionSt_qr_code_scanned = true;
    this.qrCodeScanned = true;
    await this.QRCodeGetIP(QRData);
  }

  async QRCodeGetIP(QRData) {
    if (this.webstorage.localSt_ip) {
      await this.QRCodeLoadPage(QRData);
      return;
    }
    const response = await this.ecomservice.httpGetOuterResponseHeader(EcomNetworkUtils.GET_IP_ADDRESS + this.ecomservice.GetOlarConfigValue('ipgeolocation_key'), '', false).toPromise();
    if (response.status === 200) {
      //this.ecomservice.loadingPage.loading = false;
      this.webstorage.localSt_ip = response.body.ip;
      this.webstorage.localSt_latlng = response.body.latitude + ',' + response.body.longitude;
      this.webstorage.localSt_countrycode = response.body.country_code2;
      await this.QRCodeLoadPage(QRData);
    }


  }

  async QRCodeLoadPage(QRData) {
    //console.log('get key');
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      const response = await this.ecomservice.httpPost(url, {}, '', true).toPromise();
      if (response.isSuccess) {
        //this.ecomservice.loadingPage.loading = false;
        if (!this.webstorage.localSt_client_id) {
          this.webstorage.localSt_client_id = response.listValue.oock_client_id;
        }
        // store public key
        this.webstorage.localSt_olar_key = response.listValue.oock_public_key;

      }
    }

    await this.QRCodeInitPage(QRData);
  }

  async QRCodeInitPage(QRData) {
    await this.getSettingsFromQR(QRData);

  }

  async getSettingsFromQR(data) {

    const setting = this.settingService.getCompanySetting();
    if (!setting) return;
    const qrType = this.webstorage.sessionSt_qrcode_type;
    //qrType = 'QRTABLE';
    this.webstorage.sessionSt_service_type = setting.serviceType;
    //
    this.tableName = setting['tableName']

    let QRData = {
      type: qrType,
      storeSettingId: setting['oocls_pkid'],
      settingId: '',
      locationId: setting['oocls_location_pkid'],
      companyId: '',
      areaId: '',
      tableId: setting.tablePkid,
      tableName: setting.tableName,
      //related_pkid: response_value[1]
    };

    //this.webstorage.sessionSt_qrcode_type = qrType;
    this.IsTableQRCode = qrType === 'QRTABLE';
    this.IsLocationQRCode = qrType === 'QRSTORE';
    this.IsWebUrl = false;

    //this.ecomservice.loadingPage.loading = false;

    this.webstorage.sessionSt_location_selected = setting;
    //  /}
    await this.QRCodeGetCompanySettings(QRData);


  }

  async QRCodeGetCompanySettings(QRData) {
    // let companyname = locationMasterSettings.oocls_company_name;
    // var encoded = Base64.encode(locationMasterSettings.oocls_company_id);
    // this.location.replaceState('items/' + companyname + '?webcompanyid=' + encoded);
    //this.location.replaceState(this.location.path().split('?')[0], '');
    // get location related settings
    const setting = this.settingService.getCompanySetting();
    const model = {
      oocls_location_pkid: setting.oocls_location_pkid,
      oocls_company_id: setting.oocls_company_id,
      companyPkid: setting.oocls_company_pkid
    }

    await this.fetchCustomerLoyalty();
    await this.fetchGiftcard();
    const response = await this.fetchLocationSetting(model);

    if (response) {
      const data = response;
      if (!data) return;

      this.settingService.setLocationSetting(data);
      this.settings = data;

      this.banners = data.banners;
      if (!this.serviceType) this.selectService();
      // const { slider_promotional_message, slider_promotional_message1 } = data.mm_online_order_location_settings;

      //const slider_promotional = [slider_promotional_message, slider_promotional_message1].filter(Boolean);

      //this.promotions = slider_promotional;

      this.webstorage.sessionSt_settings = this.settings;

      // get location details here
      this.webstorage.sessionSt_orderlocation_details = this.settings.mm_online_order_location_settings;

      this.locationName = this.settings.mm_online_order_location_settings.store_name;

      //console.log(this)
      // default dine in on qrcode scan
      this.locationDetails = this.webstorage.sessionSt_orderlocation_details;


      this.loadFormControls();

      // get location details here
      this.webstorage.sessionSt_orderlocation_details = this.locationDetails;


      this.setServiceTypeSessionValue();
      this.setDateTime2();

      const day = (new Date().getDate()) < 10 ? (0 + '' + (new Date().getDate())) : (new Date().getDate());
      const month = (new Date().getMonth() + 1) < 10 ? (0 + '' + (new Date().getMonth() + 1)) : (new Date().getMonth() + 1);
      this.today = new Date().getFullYear() + '-' + month + '-' + day;
      // previous request data set back to form controls if exist
      if (this.userServiceBase) {
        if (this.userServiceBase.userName && this.userServiceBase.userName.length > 1) {
          this.username = this.userServiceBase.userName ? this.userServiceBase.userName : '';
        }
        if (this.userServiceBase.userDialCode) {
          this.selectedCountryISO = this.userServiceBase.userDialCode.toLocaleLowerCase();
        }
      }

      // to initialize the form
      await this.QRCodeAddServiceRequest(QRData);
    }


  }

  async fetchLocationSetting(model: any) {
    // const data = this.settingService.getLocationSetting();
    // if (data) return data;
    const response = await this.ecomservice.httpPost(EcomNetworkUtils.POST_GET_LOCATIONS_SETTINGS, model, '', true).toPromise();
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
    } else {
      if (response.isSuccess) {
        //this.ecomservice.loadingPage.loading = false;
        this.settingService.setLocationSetting(response.listValue);
        return response.listValue;

      }
    }
  }

  async QRCodeAddServiceRequest(QRData) {
    this.QRCodeAddServiceRequestBase(QRData);
    await this.QRCodeItemInit(QRData);
  }

  getCurrentDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;

    return `${year}-${month}-${day} ${hour12}:${minutes} ${ampm}`;
  }

  QRCodeAddServiceRequestBase(QRData) {
    const locationSelected = this.settingService.getLocationSetting();
    this.userServiceBase = this.settingService.getUserSerivce();
    this.userServiceBase.userCurrentLocationIn = QRData.locationId;
    this.storeServiceBase = new StoreServiceBase({
      serviceLocationAddress: locationSelected.mm_online_order_location_settings.ools_location_addres,
      serviceLocationName: locationSelected.mm_online_order_location_settings.store_name,
      serviceType: this.serviceType,
      serviceStatus: 'OPEN',
      serviceLocationGuid: QRData.locationId,
      locationPkid: locationSelected.mm_online_order_location_settings.ools_location_pkid,
      serviceLocationAreaId: QRData.areaId,
      serviceLocationTableId: QRData.tableId,
      serviceLocationTableName: QRData.tableName,
      serviceQRScanned: this.qrCodeScanned,
      serviceCompanyId: locationSelected.company_id
    });

    //let dateArray = this.locationDetails.LocationPresentDate.split('/');
    // let year = dateArray[2];
    // let month = Number(dateArray[1]) - 1;
    // let day = dateArray[0];
    let day = moment().format('DD');
    let month = moment().format('MM');
    let year = moment().format('YYYY');
    let time = moment().format('hh:mm A');
    let datetime = this.getDateFormat(new Date(+year, +month, +day)) + ' ' + time;
    //this.storeServiceBase.serviceDatetime = datetime.replace('/','-').replace('/','-');
    this.storeServiceBase.serviceDatetime = this.getCurrentDateTime();

    if (!this.userServiceBase.selectedStoreServiceList || !this.userServiceBase.selectedStoreServiceList.length) {
      this.userServiceBase.selectedStoreServiceList = [];
      this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length + 1;
      this.webstorage.sessionSt_service_active_id = this.storeServiceBase.serviceActiveId;
      this.userServiceBase.selectedStoreServiceList.push(this.storeServiceBase);
    } else {
      // check if same location same service selected again then update details
      let storeIndex = -1;
      const storeselected = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
        storeIndex = index;
        return obj.locationPkid === locationSelected.mm_online_order_location_settings.ools_location_pkid && obj.serviceType == this.serviceType;
      });
      if (!storeselected) {
        this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length + 1;
        this.userServiceBase.selectedStoreServiceList.push(this.storeServiceBase);
        this.webstorage.sessionSt_service_active_id = this.storeServiceBase.serviceActiveId;
      } else {
        if (storeselected.serviceType === this.serviceType) {

          this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length;
          this.webstorage.sessionSt_service_active_id = storeselected.serviceActiveId;
          // set date and time to form controls
          let servicedatetime = storeselected.serviceDatetime;
          let servicedate = servicedatetime.split(' ')[0];
          let servicetime = servicedatetime.split(' ')[1] + ' ' + servicedatetime.split(' ')[2];
          datetime = servicedate + ' ' + servicetime;
          this.userServiceBase.selectedStoreServiceList[storeIndex].serviceDatetime = datetime;
        } else {
          this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length + 1;
          this.userServiceBase.selectedStoreServiceList.push(this.storeServiceBase);
          this.webstorage.sessionSt_service_active_id = this.storeServiceBase.serviceActiveId;
        }
      }
    }
    //this.webstorage.localSt_user_service_request = this.userServiceBase;
    this.settingService.setUserSerivce(this.userServiceBase)
  }

  async QRCodeItemInit(QRData?: any) {
    //this.getDiscounts(this.mm_stores.oocls_location_name);
    if (!this.userServiceBase) {
      this.router.navigate(['stores']);
      return;
    }

    this.settings = this.settingService.getCompanySetting();
    //
    this.locationSelected = this.settingService.getLocationSetting();
    this.userServiceBase = this.settingService.getUserSerivce();
    //this.locationName = this.locationSelected.oocls_location_name;
    this.companyName = this.locationSelected.company_name;
    this.locationAddress = this.locationSelected.mm_online_order_location_settings.ools_location_address;
    //this.locationDetails = this.webstorage.sessionSt_orderlocation_details;
    await this.getCategoryItems();
  }


  // Method to get the dateformat
  getDateFormat(today: Date) {
    let day = today.getDate() + '';
    let month = (today.getMonth() + 1) + '';
    let year = today.getFullYear() + '';
    let hour = today.getHours() + '';
    let minutes = today.getMinutes() + '';
    let seconds = today.getSeconds() + '';

    day = this.checkZero(day);
    month = this.checkZero(month);
    year = this.checkZero(year);
    hour = this.checkZero(hour);
    minutes = this.checkZero(minutes);
    seconds = this.checkZero(seconds);
    //return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
    return year + '-' + month + '-' + day;
  }

  // Method to append the zero
  checkZero(data) {
    if (data.length === 1) {
      data = '0' + data;
    }
    return data;
  }

  // Method to load form control
  loadFormControls() {
    this.setValidators();

  }

  // Method to set the validators
  setValidators() {
    switch (this.serviceType) {
      case 'DINE_IN':
        break;
      case 'COLLECTION':
        break;
      case 'DELIVERY':
        break;
    }
  }

  isNowInTimeRange(startTime, endTime) {
    const now = new Date();
    const nowSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    const startSeconds = this.getSeconds(startTime);
    const endSeconds = this.getSeconds(endTime);

    if (startSeconds <= endSeconds) {
      // Ví dụ: 14:00 → 23:30
      return nowSeconds >= startSeconds && nowSeconds <= endSeconds;
    } else {
      // Trường hợp qua nửa đêm: ví dụ 23:00 → 02:00
      return nowSeconds >= startSeconds || nowSeconds <= endSeconds;
    }
  }

  getSeconds(timeStr) {
    const [h, m, s] = timeStr.split(':').map(Number);
    return h * 3600 + m * 60 + s;
  }

  async onMenuClick(category: CategoryClass, index: number, scroll = false) {

    this.showOurMenu = false;
    this.showBanner = false;
    this.item_searched = false;
    this.searchValue = "";

    this.showRecommended = false;
    this.closeDrawer();
    this.selectedSubMenuId = 0;
    this.subMenus = [];
    this.isHorizontalMenu = true;
    this.selectedMenuId = category.ooic_pkid;
    // Don't center the strip to the target here: the scroll below walks the
    // spy through every section on the way, so pre-centering makes the strip
    // yo-yo (jump to target, then slide back through the ones we pass).
    // Letting the spy drive it gives a smooth one-directional slide.

    setTimeout(() => {
      this.scrollToNew(index);
    }, 500);
  }
  //  Right menu
  updateShellRight = () => {
    const rect = this.shell.nativeElement.getBoundingClientRect();
    const rightGap = Math.max(0, window.innerWidth - rect.right);
    document.documentElement.style.setProperty('--shell-right', `${rightGap}px`);
    document.documentElement.style.setProperty('--shell-width', `${rect.width}px`);
  };
  drawerOpen = false;

  @ViewChild('shell', { static: true }) shell!: ElementRef<HTMLElement>;
  @ViewChild('drawer', { static: true }) drawer!: ElementRef<HTMLElement>;
  @ViewChild('overlay', { static: true }) overlay!: ElementRef<HTMLElement>;
  private scrollResetTmr: any;

  openDrawer() {
    this.updateShellRight();
    this.drawerOpen = true;
    document.body.classList.add('mm-lock');

    // delay 1s then scrollTo top
    clearTimeout(this.scrollResetTmr);
    this.scrollResetTmr = setTimeout(() => {
      if (this.drawer && this.drawer.nativeElement) {
        const scroller = this.drawer.nativeElement.querySelector('.mm-content') as HTMLElement;
        if (scroller) {
          if (scroller.scrollTo) scroller.scrollTo(0, 0);
          else scroller.scrollTop = 0;
        }
      }
    }, 1000);
  }

  closeDrawer() {
    this.drawerOpen = false;
    document.body.classList.remove('mm-lock');
    clearTimeout(this.scrollResetTmr);
  }

  openHistory() {
    this.closeDrawer();
    this.router.navigate(['status-dinein']);
  }
  //  end right menu

  mainPage() {
    this.closeDrawer();
    this.showOurMenu = true;
    this.showBanner = true;
    this.showRecommended = true;
    this.isHorizontalMenu = false;
    this.itemList = [];
    this.subMenus = [];
  }

  onRightSideSubMenuClick(subCategory, scroll = false) {
    this.selectedSubMenuId = 0;
    const subCategoryItem = this.categoryList.find(x => x.ooic_pkid === subCategory.ooic_pkid);
    if (subCategoryItem) {
      this.itemList = subCategoryItem.items;
      this.selectedSubMenuId = subCategoryItem.ooic_pkid;
      this.selectedMenuId = subCategoryItem.ooic_parent_pkid;
      const subMenus = this.categoriesResponse.filter(x => x.ooic_parent_pkid === subCategory.ooic_parent_pkid);
      if (subMenus.length) {
        const parentPkids = subMenus.map(x => x.ooic_pkid)
        this.subMenus = this.categoryList.filter(x => parentPkids.includes(x.ooic_pkid));

        this.itemList = subCategoryItem.items;
        this.isHorizontalMenu = true;
      }
      this.closeDrawer();
      if (scroll) {
        this.scrollToItem();
      }

    }


  }
  scrollToItem() {
    setTimeout(() => {
      document.getElementById('itemList').scrollIntoView({ behavior: 'smooth' });
    }, 300);
  }


  async getCategories(companyId, locationId, orderDatetime, companyPkid: number) {
    // Short TTL cache: reuse categories when navigating back within the window
    // (see EcomSettingService.getCategoryCache); refetch after it expires so
    // time-based availability stays correct.
    const cacheKey = `${companyId}|${locationId}`;
    const cached = this.settingService.getCategoryCache(cacheKey);
    if (cached) {
      this.newCategoryList = cached.newCategoryList;
      this.allCategoryList = cached.allCategoryList;
      this.recommendedItems = cached.recommendedItems;
      this.showRecommended = cached.showRecommended;
      //this.ecomservice.loadingPage.loading = false;
      this.cdr.detectChanges();
      return;
    }

    const input = {
      company_id: companyId,
      location_pkid: locationId,
      datetime: orderDatetime,
      companyPkid: companyPkid
    };
    const response = await this.ecomservice.httpPost(EcomNetworkUtils.POST_GET_CATEGORIES, input, '', true).toPromise();
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
    } else {
      if (response.isSuccess) {
        //this.categoriesResponse = response.listValues;
        this.newCategoryList = [];

        const all = response.listValues || [];

        this.allCategoryList = all;
        // parents
        const parents = all
          .filter(x => !x.ooic_parent_pkid)
          .sort((a, b) => (a.order_sequence || 0) - (b.order_sequence || 0))
          .map(x => this.createMenu(x));

        // map submenu
        const parentMap: any = {};
        for (let i = 0; i < parents.length; i++) {
          parentMap[parents[i].ooic_pkid] = parents[i];
        }

        const subs = all
          .filter(x => x.ooic_parent_pkid)
          .sort((a, b) => (a.order_sequence || 0) - (b.order_sequence || 0))
          .map(x => this.createMenu(x));

        // attach
        for (let i = 0; i < subs.length; i++) {
          const sm = subs[i];
          const p = parentMap[sm.ooic_parent_pkid];
          if (!p) continue; //

          if (!p.subMenus) p.subMenus = [];
          p.subMenus.push(sm);
        }

        // default active submenu
        for (let i = 0; i < parents.length; i++) {
          const p = parents[i];
          if (p.subMenus && p.subMenus.length > 0) {
            p.activeSubMenuId = p.subMenus[0].ooic_pkid;
            p.items = [];
          }
        }

        this.newCategoryList = parents;

        // Fetch favorite Items
        const categoryIds = response.listValues.map(x => x.ooic_pkid);
        await this.getItems(companyId, locationId, categoryIds);

        // Store the freshly built state so a quick back-navigation can reuse it.
        this.settingService.setCategoryCache(cacheKey, {
          newCategoryList: this.newCategoryList,
          allCategoryList: this.allCategoryList,
          recommendedItems: this.recommendedItems,
          showRecommended: this.showRecommended,
        });

        this.cdr.detectChanges();


      }
    }

  }

  trackByMenu(_: number, m) {
    return m.ooic_pkid;
  }

  trackByItem(_: number, it: any) {
    return it.item_pkid;
  }

  createMenu(cat: any) {
    return {
      ooic_pkid: cat.ooic_pkid,
      ooic_parent_pkid: cat.ooic_parent_pkid,
      ooic_name: cat.ooic_pkid === 0 ? "Recommended" : cat.ooic_name,
      ooic_image: cat.ooic_pkid === 0 ? "assets/images/homeicons/Recommendation.png" : cat.ooic_image,
      ooic_alternative_name: cat.ooic_alternative_name,
      items: [],
      active: cat.availableForSelectedDateTime,
      timeList: cat.timeSlots,
      addon_pkid: cat.ooic_addon_pkid,
      order_sequence: cat.order_sequence,
      loaded: false,
      loading: false,
      subMenus: [] as any[],
      activeSubMenuId: null,
      activeSubMenu: null,
      showAddon: false,
      addon_items: [],
      addonSubMenus: [] as any[],
      activeAddonSubMenuId: null,
      activeAddonSubMenu: null
    };
  }

  showAddonClickNew(cat) {
    cat.showAddon = true;
  }

  // Method to get the category items
  async getCategoryItems() {
    await this.getDiscounts(this.locationSelected.mm_online_order_location_settings.ools_location_pkid);
    if (this.userServiceBase) {

      const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {

        //console.log(this.locationSelected.mm_online_order_location_settings.ools_location_pkid)
        return obj.locationPkid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid
          && !obj.serviceCompleted
          && obj.serviceType == this.serviceType;
      });

      if (selectedStore) {
        this.userSelectedStore = selectedStore;
      }

      const companyId = this.locationSelected.company_id;
      const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;



      await this.getCategories(companyId, locationPkid, null, this.settings.oocls_company_pkid);

      //this.ecomservice.loadingPage.loading = false;

    }
  }

  async getItems(companyId: string, locationPkid: number, categoryIds: number[]) {
    const model = {
      companyId: companyId,
      locationPkid: locationPkid,
      categoryIds: categoryIds,
      //serviceType: this.serviceType
    }

    const response = await this.ecomservice.httpPost(EcomNetworkUtils.GET_CATEGORY_ITEMS, model, '', false)
      .toPromise();
    //this.ecomservice.loadingPage.loading = false;
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
      return [];
    }

    if (response.status === 200) {
      // check res null/undefined
      const list = (response && response.listValues.length) ? response.listValues : [];
      let items = [];

      if (list.length) {

        list.forEach(element => {
          let categoryActive = element.availableForSelectedDateTime;
          if (!element.ItemPricingDineIn) return;

          element.ItemPricingDineIn.forEach(elementitem => {


            let itemprice = elementitem.ooip_price_value;
            let discountedPrice = 0;

            const categoryItemAvailable = categoryActive && elementitem.ooip_is_active && elementitem.availableForSelectedDateTime;
            //console.log("debbug");
            const item = this.mapItemData(elementitem, elementitem.item_description, elementitem.ooip_is_active, itemprice, discountedPrice, element.ooic_parent_pkid, element.ooic_pkid)
            items.push(item);
          });

          const recommended = this.newCategoryList.find(x => x.ooic_pkid === 0)

          if (recommended) {
            recommended.items = items;
            this.recommendedItems = items;
            this.showRecommended = items.length > 0;
          }

        });

        //console.log("new", items);
      }
    }


  }


  async getItemsByCategory(companyId: string, locationPkid: number, categoryId: number) {
    const model = {
      companyId,
      locationPkid,
      categoryId,
      //serviceType: this.serviceType
    }

    const response = await this.ecomservice.httpPost(EcomNetworkUtils.GET_ITEMS_BY_CATEGORY, model, '', false)
      .toPromise();
    //this.ecomservice.loadingPage.loading = false;
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
      return;
    }

    return response.listValues;
  }

  async getItemsByName(companyId: string, locationPkid: number, name: string) {
    const model = {
      companyId,
      locationPkid,
      name
    }

    const response = await this.ecomservice.httpPost(EcomNetworkUtils.GET_ITEMS_BY_NAME, model, '', true)
      .toPromise();
    //this.ecomservice.loadingPage.loading = false;
    if (response['status'] === 403) {
      this.router.navigate(['unauthorized']);
      return;
    }


    const list = (response && response.listValues && response.listValues.length) ? response.listValues : [];
    let items: any = [];

    if (list.length) {

      list.filter((element: any) => element.ItemPricingDineIn && element.ItemPricingDineIn.length).forEach((element: any) => {

        let categoryActive = true;
        const menu = this.newCategoryList.find(x => x.ooic_pkid === element.ooic_pkid);

        if (menu) {
          //const slot = menu.timeList[0];
          categoryActive = menu.active;
        }

        element.ItemPricingDineIn.forEach(elementitem => {

          let itemprice = elementitem.ooip_price_value;
          let discountedPrice = 0;

          const categoryItemAvailable = categoryActive && elementitem.ooip_is_active;
          //console.log("debbug");
          const item = this.mapItemData(elementitem, elementitem.item_description, categoryItemAvailable, itemprice, discountedPrice, element.ooic_parent_pkid, element.ooic_pkid)
          items.push(item);
        });

      });

      this.searched_item_list = items;
    }
  }

  categoriesResponse = [];

  mapItemData(elementitem, itemDescription, categoryItemAvailable, itemprice, discountedPrice, ooic_parent_pkid, ooic_pkid) {
    let price = elementitem.ooip_dinein_discount_price_value ? elementitem.ooip_dinein_discount_price_value : elementitem.ooip_price_value;
    // if (this.serviceType === "COLLECTION") {
    //   price = elementitem.ooip_collection_discount_price_value ? elementitem.ooip_collection_discount_price_value : elementitem.ooip_price_value;
    // }

    if (this.serviceType === "DELIVERY") {
      price = elementitem.ooip_delivery_discount_price_value ? elementitem.ooip_delivery_discount_price_value : elementitem.ooip_price_value;
    }

    return {
      ooip_iscvsd_pkid: elementitem.ooip_iscvsd_pkid,
      imagepath: elementitem.item_image,
      imagecolor: elementitem.item_color,
      item_pkid: elementitem.item_pkid,
      item_name: elementitem.item_name,
      item_alternative_name: elementitem.item_alternative_name,
      variants: elementitem.variants,
      item_description: itemDescription,
      store_price_value: elementitem.store_price_value,
      ooip_allow_collection: elementitem.ooip_allow_collection,
      ooip_allow_delivery: elementitem.ooip_allow_delivery,
      ooip_max_per_day: elementitem.ooip_max_per_day,
      ooip_max_per_order: elementitem.ooip_max_per_order,
      ooip_price_value: elementitem.ooip_price_value,
      quantity: 0,
      outofstock: elementitem.outofstock,
      barcode: elementitem.BarCode,
      HasVariant: elementitem.HasVariant,
      categoryAvailable: true,
      itemPrice: price,
      discountedPrice: discountedPrice,
      ooic_parent_pkid: ooic_parent_pkid,
      ooic_pkid: ooic_pkid,
      discounts: elementitem.discounts,
      variantsLoaded: false,
      //itemAvailable: this.checkAvailable()
      itemAvailable: !categoryItemAvailable ? categoryItemAvailable : elementitem.available,
    };
  }


  // Method to handle the item click event
  async onItemClick(item, type, category, event?: Event) {
    const setting = this.settingService.getLocationSetting();
    //console.log("onItemClick - table_qr_paymentmode", this.webstorage.sessionSt_settings.table_qr_paymentmode)
    // Variants already loaded
    if (item.variantsLoaded) return;

    if (item.HasVariant) {
      const clickedEl = event && event.currentTarget as HTMLElement;
      const companyId = this.locationSelected.company_id;
      const locationGuid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;

      const response = await this.ecomservice.httpGet(`${EcomNetworkUtils.GET_ITEM_VARIANTS}?companyId=${companyId}&itemPkid=${item.item_pkid}&locationId=${locationGuid}`, '', false)
        .toPromise()
      //this.ecomservice.loadingPage.loading = false;
      item.variantsLoaded = true;
      if (response.status === 200) {
        const lst = response.listValues.map(elementitem => {


          let itemDescription = '';
          if (elementitem.item_description && elementitem.item_description.length > 0) {
            itemDescription = elementitem.item_description;
          }
          let itemprice = elementitem.ooip_price_value;
          let discountedPrice = 0;
          if (elementitem.ooip_dinein_discount_price_value && elementitem.ooip_dinein_discount_price_value > 0) {
            discountedPrice = Number(elementitem.ooip_dinein_discount_price_value);
          }

          //console.log("debbug");
          const object = this.mapItemData(elementitem, itemDescription, item.categoryAvailable, itemprice, discountedPrice, item.ooic_parent_pkid, item.ooic_pkid)
          //items.push(item);

          object['discounts'] = elementitem.discounts;
          // UI-only tags so the template can visually group this variant under its parent item
          (object as any).isVariantChild = true;
          (object as any).variantParentName = item.item_name;
          (object as any).variantParentAltName = item.item_alternative_name;
          return object
        });
        if (!this.item_searched) {

          if (!category) {
            this.recommendedItems.splice(this.recommendedItems.indexOf(item) + 1, 0, ...lst);
            this.scrollToRevealVariants(clickedEl);
            return;
          }
          if (category && category.activeAddonSubMenu) {
            let arr = [...category.activeAddonSubMenu.items]; // copy
            const idx = arr.indexOf(item);
            arr.splice((idx >= 0 ? idx : -1) + 1, 0, ...lst);
            arr.sort((a, b) => a.item_name.localeCompare(b.item_name, undefined, { numeric: true }));
            category.activeAddonSubMenu.items = arr;
          } else if (category && category.showAddon) {
            let arr = [...category.addon_items];
            const idx = arr.indexOf(item);
            arr.splice((idx >= 0 ? idx : -1) + 1, 0, ...lst);
            arr.sort((a, b) => a.item_name.localeCompare(b.item_name, undefined, { numeric: true }));
            category.addon_items = arr;
          } else {
            let arr = [...category.items];
            const idx = arr.indexOf(item);
            arr.splice((idx >= 0 ? idx : -1) + 1, 0, ...lst);
            arr.sort((a, b) => a.item_name.localeCompare(b.item_name, undefined, { numeric: true }));
            category.items = arr;
          }

        } else {
          this.searched_item_list.splice(this.searched_item_list.indexOf(item) + 1, 0, ...lst);
        }

      }

      this.scrollToRevealVariants(clickedEl);
      return;
    }

    // M means view menu only
    if (this.qrCodeType === QRType.Table && setting.table_qr_paymentmode === "M") {
      this.toastService.show('The menu is available in view-only mode!');

      return;
    }

    if (this.qrCodeType === QRType.Store && setting.store_qr_paymentmode === "M") {
      this.toastService.show('The menu is available in view-only mode!');

      return;
    }


    if (type === 'PLUS') {

      this.webstorage.sessionSt_frompage = 'items';
      this.webstorage.sessionSt_item_selected = item;

      this.openDetailDrawer(item);

      //this.showDetails = true;

      return;
      let itemnameselected = item.item_name.trim().replace(/\s+/g, '-').toLowerCase();
      this.router.navigate(['item-details', this.webstorage.sessionSt_company_clicked, itemnameselected], { queryParams: { category: category.ooic_pkid } });
    }

  }

  // Once the tapped item's variant cards are spliced in, Angular renders them on the
  // next tick. Without this, a parent sitting in the right column near the bottom of
  // the viewport just dims out (variant-parent-expanded) while its new variant cards
  // land off-screen below, so the tap looks like it did nothing until the user scrolls.
  private scrollToRevealVariants(clickedEl: HTMLElement | undefined) {
    if (!clickedEl) return;
    setTimeout(() => {
      // clickedEl itself is already on-screen (the user just tapped it) — scrollIntoView
      // on it would be a no-op. The new variant cards land right after it in the DOM,
      // so that's the sibling we actually need to bring into view.
      const wrapper = clickedEl.closest('.col-6') || clickedEl;
      const target = wrapper.nextElementSibling || clickedEl;
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  onViewCartClickHanlder() {
    this.ViewCart();
  }

  checkMore() {
    // if (!this.userSelectedStore.storeCart.orderItems.length) {
    //   this.toastService.show("Please add at least 1 item to cart!");
    //   return;
    // }
    this.webstorage.sessionSt_autoOpenReward = true;

    this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked]);
  }

  // Method to handle the view cart click event
  ViewCart() {

    // make sure any one of the service type is checked
    if (!this.serviceType) {
      let message = 'Please select any one of the service to continue';
      this.serviceErrorMessage = message;
      //this.modalRef = this.modalService.show(this.locationErrorMessage, this.config);
    } else {
      this.webstorage.sessionSt_cart_location_changed = undefined;
      this.webstorage.sessionSt_frompage = 'items';
      //this.gTagViewCart(selectedStore);
      this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked]);
    }
  }


  scrollPage() {
    this.scrollToItem();
  }

  onServiceTypeClick(type) {
    this.mainPage();


    this.serviceErrorMessage = undefined;
    this.serviceType = type;
    const setting = this.settingService.getCompanySetting();
    if (setting) {
      setting.serviceType = type;
      this.companyLogo = setting.company_logo;
      this.settingService.setCompanySetting(setting);
    }
    switch (type) {
      case 'DINE_IN':

        break;
      case 'COLLECTION':

        break;
      case 'DELIVERY':

        break;
    }

    this.showOrderTypePopup = false;

    if (this.userServiceBase.selectedStoreServiceList.length > 0) {
      const defaultStore = this.userServiceBase.selectedStoreServiceList[0];
      defaultStore.serviceType = type;
      this.settingService.setUserSerivce(this.userServiceBase);
    }
    const userInfo = this.settingService.getUserInfo();
    if (this.serviceType === "DINE_IN" && userInfo.pax === 0) {
      this.modalRefPaxModal = this.modalService.show(this.paxModal, { ...this.configorderstatus, class: 'modal-dialog-centered modal-pax' });
    }
    return;

  }

  setDateTime2() {
    const userServiceBase = this.settingService.getUserSerivce();
    this.selectedDate = "Today";
    userServiceBase.selectedDate = this.selectedDate;
    this.selectedTime = this.locationDetails.LocationPresentTime;
    userServiceBase.selectedTime = this.selectedTime;

    this.settingService.setUserSerivce(userServiceBase);
  }

  // Method the handle the time change event


  showScrollTop = false;
  categoryCollapsed = false;

  onMenuScroll(el: HTMLElement) {
    this.showScrollTop = el.scrollTop > 200;

    // Collapse the category strip on scroll down, expand near the top.
    // Hysteresis (120 down / 60 up) avoids flicker at the boundary.
    if (!this.categoryCollapsed && el.scrollTop > 120) {
      this.categoryCollapsed = true;
    } else if (this.categoryCollapsed && el.scrollTop < 60) {
      this.categoryCollapsed = false;
    }

    this.updateActiveOnScroll(el);
  }

  scrollMenuToTop() {
    this.scrollRoot.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    this.showScrollTop = false;
  }

  // Total item count in the cart = sum of each line's quantity (not just
  // the number of lines), for the floating cart badge.
  getCartQuantity(): number {
    const cart = this.userSelectedStore && this.userSelectedStore.storeCart;
    if (!cart || !cart.orderItems || !cart.orderItems.length) return 0;
    return cart.orderItems.reduce((sum, it) => sum + (Number(it.quantity) || 0), 0);
  }


  setServiceTypeSessionValue() {
    switch (this.serviceType) {
      case 'DINE_IN':
        this.webstorage.sessionSt_service_type = this.serviceType;
        break;

    }
  }  // Method to get the days between two dates

  // Method to validate the pax
  onKeyPax(event) {
    const value = event.target.value;
    // validate with deposite rules

  }

  onCloseClick() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }

  searchValue: any;
  private subject: Subject<string> = new Subject();
  item_searched = false;
  searched_item_list: any[] = [];
  // Method to handle the key events
  onKey(searchtext: string) {
    this.closeDrawer();
    //key code
    this.searchValue = searchtext;
    if (!this.searchValue) {
      this.item_searched = false;
      return;
    }
    this.subject.next(this.searchValue);
  }

  async searchItem(searchtext: string) {
    this.item_searched = false;
    if (searchtext.length < 3) return;

    this.item_searched = true;
    const lowerCaseSearchText = searchtext.toLowerCase();
    const seenItems = new Set();

    this.searched_item_list = [];

    const allItems = this.flattenLoadedItems(this.newCategoryList);

    const textMatchedItems = allItems.filter(item =>
      item.item_name.toLowerCase().includes(lowerCaseSearchText)
    );

    textMatchedItems.forEach(item => {
      if (!seenItems.has(item.item_name)) {
        this.searched_item_list.push({ ...item, variantsLoaded: false });
        seenItems.add(item.item_name);
      }
    });

    // If no local data found, fetch from server
    if (this.searched_item_list.length === 0) {
      try {
        const companyId = this.locationSelected.company_id;
        const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;

        await this.getItemsByName(companyId, locationPkid, searchtext);
      } catch (error) {
        console.log('Error fetching items by name:', error);
      }
    }
  }

  flattenLoadedItems(menus: any[]) {
    const out: any[] = [];

    menus.forEach(m => {
      // no submenus
      if (!m.subMenus || m.subMenus.length === 0) {
        if (m.items.length) {
          m.items.forEach((it: any) => {
            out.push(it);
          });
        }
        return;
      }

      // has submenus
      m.subMenus.forEach((s: any) => {
        if (m.items.length) {
          s.items.forEach((it: any) => {
            out.push(it);
          });
        }
      });

      // addon
      m.addonSubMenus.forEach((s: any) => {
        if (m.items.length) {
          s.items.forEach((it: any) => {
            out.push(it);
          });
        }
      });

    });

    return out;
  }


  backToMainMenu() {
    this.item_searched = false;
    this.searchValue = '';
    var elmnt = document.getElementById('main_menu');
    if (elmnt) {
      elmnt.scrollIntoView({ behavior: 'smooth' });
    }
    let element = document.getElementById('navbar-item');
    if (element) {
      element.classList.add('location-sticky');
      element.classList.add('margin-top-0');
      element.classList.remove('search-display-block');
      element.classList.add('search-display-none');
    }
  }

  isExpanded = false;


  selectService() {
    //this.serviceTypeDrawerVisible = true;
    //if (this.userServiceBase.hasUnpaidOrder) return;
    if (this.settings.store_qr_takeaway && this.settings.store_qr_dinein)
      this.showOrderTypePopup = true;
  }

  login() {
    this.router.navigate(['login']);
  }

  openGiftCard() {
    //this.showGiftCard = true;
    const setting = this.settingService.getCompanySetting();
    const companyId = btoa(setting.oocls_company_id);

    let userPkid = null;
    const loggedInUser = this.settingService.getUserInfo();
    if (loggedInUser) {
      userPkid = loggedInUser.userPkid;
    }

    this.webstorage.sessionSt_giftCardFromPage = window.location.href;
    this.router.navigate(['giftcard'], {
      queryParams:
      {
        c: companyId,
        from: 'qr',
        u: userPkid ? btoa(userPkid.toString()) : ''
      }
    });
  }

  closeGiftCard() {
    this.showGiftCard = false;
  }

  onUserClick() {
    const setting = this.settingService.getCompanySetting();

    if (!setting) return;

    this.settingService.clearCategoryCache();

    if (setting.qrType === QRType.Table) {
      this.router.navigate(['loginnew'], { queryParams: { T: setting.tablePkid, skipResume: 1, V: generateGuid() } });

    } else if (setting.qrType === QRType.Store) {
      this.router.navigate(['loginnew'], { queryParams: { L: setting.oocls_location_pkid, C: setting.oocls_company_pkid, skipResume: 1, V: generateGuid() } });
    }

  }

  get loyaltyAmount(): number {

    const user = this.settingService.getUserInfo();
    if (user && user.userPkid > 0) {
      const amount = user.points && user.ratio ? Number((user.originPoints - this.usedPoints) / user.ratio) : 0;
      return amount;
    }
    return 0;
  }


  get usedPoints(): number {
    let point = 0;
    if (!this.userSelectedStore || !this.userSelectedStore.storeCart || !this.userSelectedStore.storeCart.orderItems) return 0;

    const userService = this.settingService.getUserSerivce();

    if (userService && userService.entireReward) {
      point = userService.entireReward.point;
    }

    const totalRewardPoints = this.userSelectedStore.storeCart.orderItems
      .filter(item => item.hasReward)
      .reduce((total, item) => total + item.reward.point, 0);

    return totalRewardPoints + point;
  }
}